/**
 * External dependencies
 */
import React from "react";

const FeaturedImage = ({ image, size = "medium_large" }) => {
	if (!image) {
		return null;
	}

	const imageSource = image[size] || image["full"];

	if (!imageSource || !imageSource.url) {
		return null;
	}

	return (
		<img
			src={imageSource.url}
			width={imageSource.width}
			height={imageSource.height}
		/>
	);
};

export default FeaturedImage;
